module.exports = __webpack_public_path__ + "static/media/facebook.61c00ab8.svg";